// Landing page image
export const staticImage: string =
  "https://img.freepik.com/free-photo/fun-3d-cartoon-illustration-indian-businessman_183364-114475.jpg?size=626&ext=jpg&ga=GA1.2.2051698419.1692458160&semt=country_rows_v2";

// Error image
export const errorImg: string =
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXlPV1nT9N3vrseo-nSxwwV-GjqHkCkSHe8A&usqp=CAU";

// Logo image
export const logo: string = "https://i.imgur.com/cNXt3eq.png";
